import { jsxs as a, jsx as l, Fragment as J } from "react/jsx-runtime";
import { enUS as oe } from "../../node_modules/date-fns/locale/en-US.mjs";
import { useRef as de, useState as p, useMemo as me, useEffect as K } from "react";
import { DatePicker as pe } from "../../node_modules/react-datepicker/dist/index.es.mjs";
import { twMerge as fe } from "tailwind-merge";
import { ButtonInput as ue } from "./components/button-Input.mjs";
import { DatePickerHeader as ge } from "./components/date-picker-header.mjs";
import { getDateRangeFilterName as he, getDateRangeCustomFilterName as xe } from "./constants/date-range-filter-loco-keys.mjs";
import { DateRangeFilterEnum as we } from "./enum/date-range-filter-enum.mjs";
import { useDateFnsLocale as ye } from "./hooks/use-date-fns-locale.mjs";
import { applyMaxInterval as Ne } from "./utills/apply-max-interval.mjs";
import { setActiveFilterValue as De } from "./utills/set-active-filter-value.mjs";
import { getDefaultCustomFilter as Q } from "./utills/set-custom-filter.mjs";
import { setDateSince as be } from "./utills/set-date-since.mjs";
import { setDateTill as ve } from "./utills/set-date-till.mjs";
import { toISOStringWithoutTimezone as g, setDateWithTimezone as n, formatDate as X } from "../../utils/date-time-format.mjs";
import { DangerButton as Te } from "../button/components/danger-button/index.mjs";
import { PrimaryButton as _e } from "../button/components/primary-button/index.mjs";
import { flip as Se, shift as ke } from "../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs";
import { getDate as R } from "../../utils/get-dates.mjs";
import { Chip as Y } from "../button/components/chip/index.mjs";
import { useTranslation as Fe } from "../../i18n/hooks.mjs";
const ze = ({
  date: S,
  light: Z,
  getDefaultDate: I,
  small: L,
  customFilters: k,
  filtersDisabled: $,
  onChange: h,
  placeholder: V,
  error: A,
  description: z,
  disabled: x,
  label: ee,
  required: te,
  maxDate: le,
  minDate: F,
  wrapperButtonInputClassName: re,
  intlLocale: c,
  createdAt: B,
  timezone: r,
  dateFormat: P,
  customProps: ae,
  labelClassName: se,
  maxInterval: O,
  showActionsSideBar: ie = !0
}) => {
  const { t: o } = Fe(), C = de(null), [ne, ce] = p(oe), i = me(
    () => (F && g(F)) ?? B,
    [F, B]
  ), H = (e) => !c || !i || !e ? e : R(i) > R(e) ? i : e, [Ce, d] = S, m = H(S[0]), [E, W] = p(), [f, w] = p(), [y, u] = p([
    m && n(m, r) || null,
    d && n(d, r) || null
  ]), [N, j] = y, [D, b] = p(
    m && n(m, r) || null
  ), [v, T] = p(
    d && n(d, r) || null
  );
  K(() => {
    !r || !i || De({
      activeFilter: f,
      timezone: r,
      setDateRange: u,
      customFilters: k || [Q(i, r)]
    });
  }, [E, f, k, i]), ye(c, ce), K(() => {
    if (m && d && r) {
      const e = n(m, r), t = n(d, r);
      u([e, t]), b(e), T(t);
    }
  }, [S, m, d, r]);
  const U = /* @__PURE__ */ a("div", { className: "flex w-full flex-col gap-3 px-2 sm:flex-row sm:gap-5", children: [
    /* @__PURE__ */ a("div", { className: "flex w-fit sm:w-full", children: [
      /* @__PURE__ */ a("span", { className: "text-text-secondary pr-1", children: [
        o("public_pages_purchase.date_picker.from"),
        ":"
      ] }),
      /* @__PURE__ */ l("span", { className: "text-text-primary", children: N ? X(N, { dateFormat: P }) : "-" })
    ] }),
    /* @__PURE__ */ a("div", { className: "flex w-fit sm:w-full sm:pl-2", children: [
      /* @__PURE__ */ a("span", { className: "text-text-secondary pr-1", children: [
        o("public_pages_purchase.date_picker.to"),
        ":"
      ] }),
      /* @__PURE__ */ l("span", { className: "text-text-primary", children: j ? X(j, { dateFormat: P }) : "-" })
    ] })
  ] }), q = /* @__PURE__ */ a(J, { children: [
    /* @__PURE__ */ l(
      Te,
      {
        disabled: x,
        onClick: () => {
          var e;
          if ((e = C.current) == null || e.setOpen(!1), I) {
            const [t, s] = I(), M = H(t) ?? void 0, _ = n(M, r), G = n(s, r);
            T(G), b(_), h([
              g(_),
              g(G)
            ]);
          } else
            T(null), b(null), h([null, null]);
          W(void 0);
        },
        className: "w-full",
        children: o("public_pages_purchase.date_picker.clear")
      }
    ),
    /* @__PURE__ */ l(
      _e,
      {
        disabled: !y[0] || !y[1] || x,
        className: "w-full",
        onClick: () => {
          var s;
          const [e, t] = y;
          e && t ? (b(e), T(t), W(f), be(e), ve(t), h([g(e), g(t)])) : h([null, null]), (s = C.current) == null || s.setOpen(!1);
        },
        children: o("public_pages_purchase.date_picker.apply")
      }
    )
  ] });
  return /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
    pe,
    {
      ref: C,
      shouldCloseOnSelect: !1,
      selectsRange: !0,
      monthsShown: 2,
      selected: N,
      startDate: N,
      className: "w-full",
      calendarClassName: "date-range-picker",
      onCalendarClose: () => {
        u([D, v]), w(E);
      },
      calendarContainer: ie ? (e) => /* @__PURE__ */ a(
        "div",
        {
          ...e,
          className: fe(
            "flex flex-col justify-center gap-4 sm:flex-row sm:gap-5",
            e.className
          ),
          children: [
            /* @__PURE__ */ a("div", { className: "flex flex-col gap-4 md:mb-4", children: [
              /* @__PURE__ */ l("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: e.children }),
              U
            ] }),
            /* @__PURE__ */ a("div", { className: "sm:border-text-secondary/30 flex w-full flex-col items-center justify-center gap-5 border-transparent sm:m-auto sm:border-t sm:p-2 md:w-fit md:border-l md:border-t-0 md:pl-5", children: [
              /* @__PURE__ */ a("ul", { className: "hidden w-1/2 gap-5 sm:flex sm:flex-col md:w-full", children: [
                Object.values(we).map((t) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ l(
                  Y,
                  {
                    className: "w-full",
                    disabled: !r || $ || x,
                    onClick: () => {
                      w(t);
                    },
                    selected: t === f,
                    children: he(t, o)
                  }
                ) }, t)),
                (k || [Q(i, r)]).map(
                  (t) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ l(
                    Y,
                    {
                      className: "w-full",
                      disabled: $ || x,
                      onClick: () => {
                        w(t.slug);
                      },
                      selected: t.slug === f,
                      children: xe(t.slug, o)
                    }
                  ) }, t.slug)
                )
              ] }),
              /* @__PURE__ */ l("div", { className: "flex w-full justify-between gap-3 sm:w-1/2 md:w-full", children: q })
            ] })
          ]
        }
      ) : (e) => /* @__PURE__ */ a("div", { ...e, children: [
        /* @__PURE__ */ l("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: e.children }),
        U,
        /* @__PURE__ */ l("div", { className: "flex w-full justify-center gap-3", children: q })
      ] }),
      endDate: j,
      minDate: R(i, r),
      maxDate: le,
      dateFormat: "MMMM d, yyyy",
      onChange: (e) => {
        if (e) {
          w(void 0);
          const [t, s] = e;
          u(O ? Ne(t, s, O) : [t, s]);
        }
      },
      locale: ne,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperModifiers: [Se(), ke({ padding: 5, crossAxis: !0 })],
      showPopperArrow: !1,
      customInput: /* @__PURE__ */ l(
        ue,
        {
          buttonInputClassName: `flex group justify-between ${L ? "" : "min-w-[150px] lg:min-w-[200px]"} w-full py-2.5 px-4 text-sm font-medium ${Z ? "text-[rgb(var(--text-tertiary))]" : "text-text-primary"} border ${A ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          wrapperButtonInputClassName: re,
          labelClassName: se,
          error: A,
          label: ee,
          required: te,
          description: z,
          children: () => /* @__PURE__ */ l("span", { className: "text-start whitespace-nowrap", children: D && v ? /* @__PURE__ */ a(J, { children: [
            /* @__PURE__ */ l("span", { className: "hidden lg:inline", children: `${new Intl.DateTimeFormat(c, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(D)} - ${new Intl.DateTimeFormat(c, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(v)}
              ` }),
            /* @__PURE__ */ l("span", { className: "inline lg:hidden", children: `${new Intl.DateTimeFormat(c, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(D)} - ${new Intl.DateTimeFormat(c, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(v)}
              ` })
          ] }) : /* @__PURE__ */ l("span", { className: "text-text-tertiary/70", children: V || o("public_pages_purchase.date_picker.title_dates") }) })
        }
      ),
      renderCustomHeader: ({
        monthDate: e,
        decreaseMonth: t,
        increaseMonth: s,
        prevMonthButtonDisabled: M,
        nextMonthButtonDisabled: _
      }) => /* @__PURE__ */ l(
        ge,
        {
          date: e,
          decreaseMonth: t,
          increaseMonth: s,
          prevMonthButtonDisabled: M,
          nextMonthButtonDisabled: _,
          intlLocale: c
        }
      ),
      ...ae
    }
  ) });
};
export {
  ze as DateRangePicker
};
